import { Grid, moneyFormatNoDecimal, P, Stack, Text, tw, useText } from "@sveabank/cc-common";
import Card from "../../../components/card";
import LinearProgress from "../../../components/linear-progress";
import type { CreditScoreStepState } from "../../../types/step";
import { calculateCreditPercentage } from "../helpers";

type Props = {
	creditScore: CreditScoreStepState;
	remainingCredit: number;
};

const CreditConfigStatus = ({ creditScore, remainingCredit }: Props) => {
	const [t, texts] = useText();
	const hasNegativeCredit = remainingCredit < 0;
	return (
		<Card classNames="bg-background-tertiary" fullWidth boxShadow={false}>
			<div className="w-full">
				<Grid>
					<Grid.Col span={{ base: 12, tablet: 6, laptop: 4 }}>
						<Stack direction="row" gap={4}>
							<P bold>{t(texts.adjustCredit.creditPoolDescription)}</P>
							<Text
								className={tw("text-xl", hasNegativeCredit ? "interactive-cancel" : "text-primary")}
								bold
							>
								{moneyFormatNoDecimal(remainingCredit, true)}
							</Text>
						</Stack>
					</Grid.Col>
					<Grid.Col span={{ base: 12, tablet: 6, laptop: 8 }}>
						<Stack gap={1}>
							<LinearProgress value={calculateCreditPercentage(remainingCredit, creditScore)} />
							{hasNegativeCredit && (
								<Text className="text-interactive-cancel text-sm">
									{t(texts.adjustCredit.creditExceededWarning)}
								</Text>
							)}
						</Stack>
					</Grid.Col>
				</Grid>
			</div>
		</Card>
	);
};

export default CreditConfigStatus;
